export enum ReferralDisplayStatus {
  SIGN_UP = 'Sign Up',
  TRIALIST = 'Trialist',
  AWAITING_VERIFICATION = 'Awaiting verification',
  COMPLETED = 'Completed',
  REJECTED = 'Rejected'
}
